module.exports = __webpack_public_path__ + "img/9.6fe7c6d0.png";